<template>
  <label
    :for="labelFor"
    class="col-form-label"><slot /></label>
</template>

<script>
export default {
  props: {
    labelFor: {
      type: String,
      default: null
    }
  }
}
</script>

<style>

</style>